import {
  QuickLoginPromptTrackingPoint,
  ReloginQuickLoginTrackingPoint,
} from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const QuickLoginPromptTrackingSchema: Record<
  QuickLoginPromptTrackingPoint,
  string
> = {
  [QuickLoginPromptTrackingPoint.QuickLoginPromptPageView]: '',
  [QuickLoginPromptTrackingPoint.QuickLoginPromptEnableQuickLoginClick]: '',
  [QuickLoginPromptTrackingPoint.QuickLoginPromptBackClick]: '',
};

const ReloginQuickLoginTrackingSchema: Record<
  ReloginQuickLoginTrackingPoint,
  string
> = {
  [ReloginQuickLoginTrackingPoint.PageView]: '',
  [ReloginQuickLoginTrackingPoint.ReloginWithOtherMethodsClick]: '',
  [ReloginQuickLoginTrackingPoint.LoginWithOtherMethodsSelectionImpression]: '',
  [ReloginQuickLoginTrackingPoint.LoginWithOtherMethodsSelectionClick]: '',
  [ReloginQuickLoginTrackingPoint.ReloginWithAnotherAccountClick]: '',
  [ReloginQuickLoginTrackingPoint.ReloginSignupClick]: '',
  [ReloginQuickLoginTrackingPoint.QuickLoginClick]: '',
};

export const getQuickLoginPromptPageTypeAndSchema = (
  trackingPoint: QuickLoginPromptTrackingPoint
) => {
  return {
    page_type: PageType.QuickLoginPromptPage,
    schema: QuickLoginPromptTrackingSchema[trackingPoint],
  };
};

export const getReloginQuickLoginPageTypeAndSchema = (
  trackingPoint: ReloginQuickLoginTrackingPoint
) => {
  return {
    page_type: PageType.ReloginQuickLoginPage,
    schema: ReloginQuickLoginTrackingSchema[trackingPoint],
  };
};
